<template>
  <div class="store-page" :style="!isNormal?'padding-bottom: 10px':false">
    <v-header class="store-page_title">G幣儲值</v-header>
    <user-content class="store-page_info" :avatar="avatar" :user-name="userName">
      <p class="wallet-balance">
        您的錢包餘額：
        <span class="balance-value">{{walletBalance}} G幣</span>
      </p>
    </user-content>
    <div class="channel-pick" v-show="!hideMain">
      <div class="channel-pick_landscape-icon"></div>
      <div class="channel-pick_landscape-content">
        <div class="channel-pick_item">
          <p class="channel-pick_item--title">選擇國家/地區</p>
          <popup-selector
            :show-icon="false"
            class="channel-pick_item--picker j-select-area-dcount"
            @show-popup="popupShow('regions')"
          >
            <span class="channel-name j-select-area-dcount">{{curRegion.name}}</span>
          </popup-selector>
        </div>
        <div class="channel-pick_item">
          <p class="channel-pick_item--title">選擇兌換渠道</p>
          <popup-selector
            :icon="curChannel.icon"
            class="channel-pick_item--picker j-select-channel-dcount"
            @show-popup="popupShow('channels')"
          >
            <span class="channel-name j-select-channel-dcount">{{curChannel.name || '暫無數據'}}</span>
            <span class="channel-tips" v-if="curChannel.tips">贈</span>
          </popup-selector>
        </div>
        <div class="channel-pick_item" v-if="showCreditCard">
          <p class="channel-pick_item--title">已保存的信用卡</p>
          <popup-selector
            :showIcon="false"
            class="channel-pick_item--picker j-select-channel-dcount"
            @show-popup="popupShow('creditCards')"
          >
            <span class="channel-name j-select-channel-dcount">{{curCreditCard.name || '使用新的信用卡'}}</span>
          </popup-selector>
        </div>
        <div class="channel-pick_item" v-if="isNormal&&curChannel.info&&curChannel.info.needDetail">
          <p class="channel-pick_item--title">{{subTitle}}</p>
          <popup-selector
            :show-icon="false"
            class="channel-pick_item--picker j-select-subchannel-dcount"
            @show-popup="popupShow('subchannels')"
          >
            <span class="channel-name j-select-subchannel-dcount">{{curSubchannel.name || subTitle}}</span>
          </popup-selector>
        </div>
        <div class="channel-pick_item" v-if="!isPortrait || !isNormal">
          <p class="channel-pick_item--title">選擇兌換面额</p>
          <popup-selector
            :show-icon="false"
            class="channel-pick_item--picker j-select-store-value-dcount"
            @show-popup="popupShow('denominations')"
          >
            <span class="channel-name j-select-store-value-dcount">{{curStore.name || '選擇兌換面额'}}</span>
            <span class="channel-tips" v-if="curStore.more">贈</span>
          </popup-selector>
        </div>
        <div class="channel-pick_item income" v-if="(!isNormal&&curStore.id)||!isPortrait">
          <p class="channel-pick_item--title">最終獲取</p>
          <div class="channel-pick_item--picker income">
            <span class="platform-income" v-if="curStore.platformValue">
              {{curStore.platformValue}}
              <span class="platform-unit">G幣</span>
            </span>
          </div>
        </div>
        <div class="channel-store_msg" v-if="false">{{storeMsg}}</div>
        <div
          class="channel-store_pay"
          v-if="!isPortrait&&curStore.id"
        >需支付：{{curStore.TRANS_AMOUNT}}{{curStore.CURRENCY}}</div>
        <pl-gradient-btn
          v-if="!isPortrait"
          class="landscape-btn j-currency-submit-dcount"
          @click="handleLandscape"
        >{{landscapeText}}</pl-gradient-btn>
      </div>
    </div>
    <div class="store-value" v-if="isPortrait && isNormal">
      <p class="block-title">選擇兌換面額</p>
      <div
        class="store-value_list"
        :class="[curChannel.info && curChannel.info.needDetail ? 'detail' : false]"
        v-if="denominations.length"
      >
        <div
          :key="item.id"
          class="store-value_item j-store-value_item"
          :data-payment="item.platformValue"
          @click="selectStore(item)"
          v-for="item in denominations"
          :class="[curStore.id === item.id ? 'active' : false]"
        >
          <div class="coupon-icon" v-if="item.more"></div>
          <div class="coupon-tips" v-if="item.more">{{item.more}}</div>
          <div class="platform-value" :class="[item.more ? 'has-tips' : false]">
            <span class="platform-number">{{item.platformValue}}</span>
            <span class="platform-value_spec">G幣</span>
          </div>
          <div class="real-value" v-if="item.realValue">{{item.realValue}}{{item.CURRENCY}}</div>
        </div>
      </div>
    </div>
    <!-- 點卡輸入 -->
    <points-input
      @back="hideMain=false"
      @exchange-points="store"
      :is-portrait="isPortrait"
      class="points-input_content"
      :class="!isPortrait?'channel-pick points':false"
      v-if="isPoints && curStore.id && (isPortrait || hideMain)"
    ></points-input>
    <!-- 銀行匯款 -->
    <bank-transfer
      :store="curStore"
      ref="bankTransfer"
      class="bank-content"
      :user-name="userName"
      @back="hideMain=false"
      @get-bank-account="store"
      :is-portrait="isPortrait"
      :class="!isPortrait?'channel-pick':false"
      v-if="isBank && curStore.id && (isPortrait || hideMain)"
    ></bank-transfer>
    <common-footer class="common-footer"></common-footer>
    <div class="confirm-btn j-currency-submit-dcount" @click="store" v-if="isPortrait&&isNormal">確認</div>
    <popup-picker
      v-if="pickerShow"
      :list="list"
      :title="pickerTitle"
      :activeListEdit="activeListEdit"
      @select="pickerSelect"
      @close="pickerShow = false"
      @editLists="editLists"
      @saveLists="saveLists"
      @delListItem="delListItem"
      class="channel-popup_picker"
    ></popup-picker>
    <form style="display:none;" :action="postAction" method="POST">
      <input
        type="hidden"
        v-for="(value, name) in postFields"
        :key="name"
        :value="value"
        :name="name"
      />
      <input style="display:none;" type="submit" ref="submitForm" />
    </form>
    <pl-tips v-if="showTips" @close="showTips=false">
      <template #body>
        <p style="width: 100%;padding: 10px;box-sizing: border-box; text-align: center;">
          <span style="display: inline-block; text-align: left;">{{tipsContent}}</span>
        </p>
      </template>
    </pl-tips>
    <pl-tips v-if="showDelCreditCardTip" @close="showDelCreditCardTip=false" class="big">
      <template #body>
        <div class="del-credit">
          <p class="del-credit_text">刪除後，若您希望再次使用該信用卡，請選擇“使用新的信用卡”。</p>
          <div class="del-credit_btns">
            <a href="javascript:void(0);" class="del-credit_btns_cancel" @click="cancelDelCreditCard">取消</a>
            <a href="javascript:void(0);" class="del-credit_btns_confirm" @click="confirmDelCreditCard">確認</a>
          </div>
        </div>
      </template>
    </pl-tips>
  </div>
</template>

<script>
import qs from 'qs'
import plTips from '@/components/pl-tips'
import vHeader from '@/components/header'
import userContent from '@/components/user-info'
import { mapGetters, mapMutations } from 'vuex'
import PopupPicker from '@/components/popup-picker'
import pointsInput from '@/components/points-input'
import commonFooter from '@/components/common-footer'
import bankTransfer from '@/components/bank-transfer'
import popupSelector from '@/components/popup-selector'
import plGradientBtn from '@/components/pl-gradient-btn'
import { isEmptyObj, convertStringToParam, formatDate, getHrefParamFromLocation as getHrefParam } from '@/utils'

 const useNewCardItem = {
  id: '',
  name: '使用新的信用卡'
}

export default {
  name: 'StorePage',
  components: {
    plTips,
    vHeader,
    userContent,
    pointsInput,
    PopupPicker,
    commonFooter,
    bankTransfer,
    popupSelector,
    plGradientBtn
  },
  data () {
    return {
      userName: '',
      avatar: '',
      walletBalance: 100,
      list: [],
      pickerShow: false,
      pickerType: '',
      pickerTitle: '',
      activeListEdit: false,
      regions: [],
      denominations: [],
      subchannels: [],
      creditCards: [],
      curStore: {},
      curRegion: {},
      curChannel: {},
      curSubchannel: {},
      curCreditCard: {},
      delListItemId: '',
      init: false,
      storeMsg:
        '儲值提示：本管道可啟動（$0.99,$4.99,$14.99,$19.99）四選一首儲禮包，單次儲值大於4檔位任一才能啟動該檔位禮包（例如300新台幣可啟動$4.99首儲禮包）超過檔位的金額將照比例折算鑽石。',
      postFields: [],
      postAction: '',
      hideMain: false,
      showTips: false,
      showDelCreditCardTip: false,
      showCreditCard: false,
      tipsContent: '',
      lastPayChannel: '',
      lastPaySubChannel: '',
      lastPayStore: '',
      storeParams: {},
      pointsGap: 0,
      fromUrl: '',
      tmpHref: '',
      isOpenCoupon: true
    }
  },
  computed: {
    ...mapGetters({
      channels: 'getChannels',
      isPortrait: 'getDeviceDirection',
      userInfo: 'getUserInfo'
    }),
    subTitle () {
      let obj = {
        mycard_webatm: '請選擇銀行',
        mycard_telephone: '請選擇運營商',
        mycard_credit_card: '選擇付款方式'
      }
      if (this.curChannel.info && this.curChannel.info.needDetail) {
        return obj[this.curChannel.id]
      }
      return ''
    },
    isNormal () {
      if (
        this.curChannel.info &&
        (this.curChannel.info.isBank || this.curChannel.info.isPoints)
      ) {
        return false
      }
      return true
    },
    isBank () {
      if (!this.isNormal && this.curChannel.info.isBank) {
        return true
      }
      return false
    },
    isPoints () {
      if (!this.isNormal && this.curChannel.info.isPoints) {
        return true
      }
      return false
    },
    landscapeText () {
      if (this.isBank) {
        return '獲取匯款賬號'
      }
      if (this.isNormal) {
        return '提交訂單'
      }
      if (this.isPoints) {
        return '卡密輸入'
      }
      return ''
    }
  },
  watch: {
    channels (list) {
      if (!list.length) {
        return
      }
      if (this.lastPayChannel) {
        let channelId =
          typeof this.lastPayChannel === 'string'
            ? this.lastPayChannel
            : this.lastPayChannel.id
        this.curChannel = list.find((item) => item.id === channelId) || list[0]
        this.lastPayChannel = ''
      } else {
        this.curChannel = list[0]
      }
    },
    curRegion () {
      if (!this.init) {
        return
      }
      this.curChannel = {}
      this.retsetData()
      this.fetchChannels()
    },
    curChannel (channel) {
      if (!this.init || isEmptyObj(channel)) {
        return
      }
      this.retsetData()
      if (channel.info && channel.info.needDetail) {
        this.fetchSubchannel()
      } else {
        this.fetchProducts(channel)
      }

      if(channel.fid === 'world_pay' && channel.creditCards.length > 0) {
        this.creditCards = this.serialCreditCards(this.curChannel.creditCards);
        this.curCreditCard = this.creditCards[0];
        this.showCreditCard = true;
      } else {
        this.creditCards = [];
        this.curCreditCard = {};
        this.showCreditCard = false;
      }
    },
    curSubchannel (channel) {
      if (!this.init || isEmptyObj(channel)) {
        return
      }
      this.denominations = []
      this.curStore = {}
      this.fetchProducts(channel)
    }
  },
  methods: {
    ...mapMutations({ genChannels: 'generateChannels' }),
    serialCreditCards (list) {
      const newList = list.reduce((arr, item) => {
        const serialData = { 
          id: item.KEY_VALUE,
          name: item.KEY_VALUE_DESC
        };
        arr.push(serialData);
        return arr;
      }, []);
      newList.push(useNewCardItem);
      return newList;
    },
    delListItem(keyValue) {
      this.delListItemId = keyValue;
      this.showDelCreditCardTip = true;
    },
    editLists() {
      if(this.pickerType === 'creditCards') {
        this.editCreditCards();
      }
    },
    saveLists() {
      if(this.pickerType === 'creditCards') {
        this.saveCreditCards();
      }
    },
    editCreditCards() {
      const oldCreditCards = this.list;
      const newCreditCards = [];
      for(let i = 0; i < oldCreditCards.length; i++) {
        oldCreditCards[i].id !== '' && newCreditCards.push(oldCreditCards[i]);
      }
      this.list = newCreditCards;
    },
    saveCreditCards() {
      const emptyItem = this.list.find((item) => {
        return item.id === '';
      })
      !emptyItem && this.list.push(useNewCardItem);
    },
    cancelDelCreditCard() {
      this.showDelCreditCardTip = false;
      this.delListItemId = '';
    },
    confirmDelCreditCard() {
      const params = {
        f_pay_type: this.curChannel.fid,
        pay_type: this.curChannel.id,
        key_value: this.delListItemId,
        currency: this.curChannel.currency
      }
      const succHandle = () => {
        this.$store.commit('deleteCreditCards', {
          payType: this.curChannel.id,
          keyValue: this.delListItemId
        });
        const newLists = this.creditCards.filter((item) => {
          return item.id !== this.delListItemId && item.id !== '';
        })
        this.creditCards = newLists;
        this.list = newLists;
        this.cancelDelCreditCard();
        if(newLists.length < 1) {
          this.pickerShow = false;
          this.curCreditCard = useNewCardItem;
          this.creditCards = [useNewCardItem];
          this.list = [useNewCardItem];
        } else {
          this.curCreditCard = this.creditCards[0];
        }
      }
      const errorHandle = () => {
        this.cancelDelCreditCard();
        this.showTipsPopup('刪除失敗，請聯繫客服人員！')
      };
      if(!params.f_pay_type || !params.pay_type || !params.key_value) {
        errorHandle();
        return;
      }
      this.$jsonp(
        '//mstore.gm99.com/world_pay/del_user_pay_type_infos',
        params
      )
        .then((res) => {
          +res.result === 1 ? succHandle() : errorHandle();
        })
        .catch((err) => {
          errorHandle();
        })
      
    },
    retsetData (type) {
      this.curSubchannel = {}
      this.subchannels = []
      this.curStore = {}
      this.denominations = []
    },
    back () {
      this.$router.go(-1)
    },
    generateParams () {
      let queryParams = {}
      if (window.location.search) {
        queryParams = convertStringToParam(window.location.search)
      }
      let keys = Object.keys(this.$route.query)
      let hasRestore = this.tmpHref.indexOf('reStore=') >= 0
      let obj = {}
      obj.restoreUrl = encodeURIComponent(
        `${this.tmpHref}${
          hasRestore ? '' : keys.length ? '&reStore=1' : '?reStore=1'
        }`
      )
      if (this.pointsGap) {
        obj.fromUrl = this.fromUrl
      }
      return {
        ...queryParams,
        ...this.storeParams,
        flowType: 1,
        paytype: this.curSubchannel.id
          ? this.curSubchannel.id
          : this.curChannel.id,
        productId: this.curStore.id,
        currency: this.curStore.CURRENCY,
        account: this.userName,
        unused: +this.walletBalance + +this.curStore.platformValue,
        productName: this.curStore.name,
        time: formatDate(Date.now(), 'yyyy-MM-dd hh:mm'),
        payMoney: this.curStore.TRANS_AMOUNT + this.curStore.CURRENCY,
        keyValue: this.curCreditCard.id,
        ...obj,
        cid: getHrefParam('cid') || '',
        scid: getHrefParam('scid') || '',
      }
    },
    handleLandscape () {
      if (!this.curStore.id) {
        this.showTipsPopup('請選擇兌換面額')
        return
      }
      if (!this.isNormal && !this.isPortrait) {
        this.hideMain = true
        return
      }
      this.store()
    },
    showTipsPopup (str) {
      this.tipsContent = str
      this.showTips = true
    },
    store (cardInfo) {
      if (!this.curStore.id) {
        this.showTipsPopup('請選擇兌換面額')
        return
      }
      let storeParams = {
        curRegion: this.curRegion,
        curChannel: this.curChannel.id,
        curSubchannel: this.curSubchannel.id || '',
        curStore: this.curStore.id
      }
      window.localStorage.setItem('storeParams', JSON.stringify(storeParams))
      let params = this.generateParams()
      this.$store.commit('setLoadingState', true)
      try {
        this.$datain({
          ext3: '提交訂單',
          ext4: this.curChannel.id,
          ext5: this.curSubchannel.id ? this.curSubchannel.id : '',
          ext10: this.curRegion.id,
          ext11: this.curStore.id,
          resetAllEvent: true
        })
        window.sdkBehave.push({
          event: '提交訂單',
          type: 'gm_wallet',
          payway: this.curChannel.id,
          product: params.productName,
          gaEventName: 'submitOrder'
        })
      } catch (e) {}
      this.$http
        .post(
          `//mstore.gm99.com/${this.curChannel.fid}/submit`,
          qs.stringify(params),
          {
            withCredentials: true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }
        )
        .then((res) => {
          res = res.data
          if (+res.result === 1) {
            try {
              this.$datain({
                ext3: '提交訂單成功',
                ext4: this.curChannel.id,
                ext5: this.curSubchannel.id ? this.curSubchannel.id : '',
                ext10: this.curRegion.id,
                ext11: this.curStore.id
              })
              window.localStorage.setItem(window.UID, '提交訂單成功')
              window.localStorage.setItem(
                'storeObj',
                JSON.stringify({
                  ext4: this.curChannel.id,
                  ext5: this.curSubchannel.id ? this.curSubchannel.id : '',
                  ext10: this.curRegion.id,
                  ext11: this.curStore.id
                })
              )
              window.sdkBehave.push({
                event: '提交訂單成功',
                type: 'gm_wallet',
                payType: res.data.type,
                gaEventName: 'submitOrderSuccess'
              })
            } catch (e) {}
            switch (+res.data.type) {
              case 1:
                window.location.href = res.data.redirect_url
                break
              case 2:
                if (cardInfo) {
                  res.data.post_fields = {
                    ...res.data.post_fields,
                    ...cardInfo
                  }
                }
                this.postAction =
                  res.data.post_fields.submit_url || res.data.redirect_url
                this.postFields = res.data.post_fields
                this.$nextTick(() => {
                  this.$refs.submitForm.click()
                })
                break
              case 5:
                let virtualAccountInfo = res.data.virtual_account_info
                this.$refs.bankTransfer.setBankAccount(
                  virtualAccountInfo.virtual_account
                )
                break
            }
            this.$store.commit('setLoadingState', false)
          } else {
            this.$store.commit('setLoadingState', false)
            this.showTipsPopup(res.msg)
            try {
              this.$datain({
                ext3: '提交訂單失敗',
                ext4: this.curChannel.id,
                ext5: this.curSubchannel.id ? this.curSubchannel.id : '',
                ext10: this.curRegion.id,
                ext11: this.curStore.id,
                ext13: res.msg + '-' + res.code
              })
              window.sdkBehave.push({
                event: '提交訂單失敗',
                type: 'gm_wallet',
                reason: res.msg,
                code: res.code,
                gaEventName: 'submitOrderFail'
              })
            } catch (e) {}
          }
        })
        .catch((err) => {
          this.showTipsPopup(err.message || '系統錯誤')
          try {
            this.$datain({
              ext3: '提交訂單異常',
              ext4: this.curChannel.id,
              ext5: this.curSubchannel.id ? this.curSubchannel.id : '',
              ext10: this.curRegion.id,
              ext11: this.curStore.id,
              ext13: err.msg
            })
            window.sdkBehave.push({
              event: '提交訂單異常',
              type: 'gm_wallet',
              reason: err.message || '系統錯誤',
              gaEventName: 'submitOrderError'
            })
          } catch (e) {}
        })
    },
    preHandleList(type) {
      if(type === 'creditCards') {
        let newCardItem = this[type].find((item) => {
          return item.id === ''
        })
        !newCardItem && this[type].push(useNewCardItem)
      }
    },
    popupShow (type) {
      let title = {
        regions: '請選擇國家/地區',
        channels: '請選擇兌換渠道',
        creditCards: '請選擇信用卡',
        denominations: '請選擇兌換面額',
        subchannels: this.subTitle
      }
      let datainInfo = {
        regions: '點擊地區切換',
        channels: '點擊渠道切換',
        creditCards: '點擊信用卡切換',
        denominations: '點擊兌換面額選擇框',
        subchannels: '點擊子渠道切換'
      }
      let needEditList = ['creditCards'];
      this.preHandleList(type)
      this.init = true
      this.pickerType = type
      this.list = this[type]
      this.pickerTitle = title[type]
      this.pickerShow = true
      this.activeListEdit = needEditList.includes(type)
      this.$datain({ ext3: datainInfo[type] })
    },
    pickerSelect (data) {
      let event = ''
      let gaEventName = ''
      if (this.pickerType === 'regions') {
        this.curRegion = data
        event = '選擇地區'
        gaEventName = 'selectArea'
      } else if (this.pickerType === 'channels') {
        this.curChannel = data
        event = '選擇渠道'
        gaEventName = 'selectWays'
      } else if (this.pickerType === 'denominations') {
        this.curStore = data
        event = '選擇金額'
        gaEventName = 'selectMoney'
      } else if (this.pickerType === 'subchannels') {
        this.curSubchannel = data
        event = '選擇子渠道'
        gaEventName = 'selectChildWays'
      } else if(this.pickerType === 'creditCards') {
        this.curCreditCard = data
        event = '選擇信用卡'
        gaEventName = 'selectCreditCard'
      }

      try {
        this.$datain({
          ext3: event,
          ext10: this.curRegion.id || '',
          ext11: this.curStore.id || ''
        })
        window.sdkBehave.push({
          event,
          gaEventName,
          name: data.name,
          type: 'gm_wallet'
        })
      } catch (e) {
        console.warn(e)
      }
    },
    fetchChannels () {
      this.$jsonp('//mstore.gm99.com/points/show_paytype', {
        location: this.curRegion.id
      })
        .then((res) => {
          let data = res.data
          if (+res.result >= 1) {
            this.genChannels({ channels: data, isOpenCoupon: this.isOpenCoupon })
          } else {
            this.showTipsPopup(res.msg)
          }
        })
        .catch((err) => {
          this.showTipsPopup(err.message || '系統錯誤')
        })
    },
    fetchSubchannel () {
      this.$jsonp(
        '//mstore.gm99.com/mycard_common_tw/show_mycard_billing_catalog',
        {
          catalog: this.curChannel.info.catalog
        }
      )
        .then((res) => {
          let data = res.data
          if (+res.result >= 1) {
            this.subchannels = data.map((item) => {
              let obj = {
                id: item[1],
                name: item[3],
                icon: '',
                fid: item[0],
                currency: item[2]
              }
              return obj
            })
            if (this.lastPaySubChannel) {
              let channelId =
                typeof this.lastPaySubChannel === 'string'
                  ? this.lastPaySubChannel
                  : this.lastPaySubChannel.id
              this.curSubchannel =
                this.subchannels.find((item) => item.id === channelId) ||
                this.subchannels[0]
              this.lastPaySubChannel = ''
            } else if (this.subchannels.length === 1) {
              this.curSubchannel = this.subchannels[0]
            }
          } else {
            this.showTipsPopup(res.msg)
          }
        })
        .catch((err) => {
          this.showTipsPopup(err.message || '系統錯誤')
        })
    },
    fetchProducts (channel) {
      this.$jsonp('//mstore.gm99.com/points/show_product', {
        fpaytype: channel.fid,
        paytype: channel.id,
        currency: channel.currency
      })
        .then((res) => {
          let data = res.data
          if (+res.result >= 1) {
            this.denominations = data.map((item) => {
              item.id = item.PRODUCT_ID
              if (channel.id === 'virtual_account') {
                item.name =
                  item.TRANS_AMOUNT + item.CURRENCY + `=${item.POINTS}G幣`
              } else if (channel.info && channel.info.isPoints) {
                item.name = `${item.TRANS_AMOUNT}點=${item.POINTS}G幣`
              } else {
                item.name = `${item.TRANS_AMOUNT}${item.CURRENCY}=${item.POINTS}G幣`
              }
              item.platformValue = item.POINTS
              item.realValue = item.TRANS_AMOUNT
              if (+item.COUPON_POINTS_NUM && this.isOpenCoupon) {
                item.couponMsg = item.more = `贈${item.COUPON_POINTS_NUM}G幣抵用券*${item.COUPON_NUM}張`
              }
              return item
            })
            if (this.lastPayStore) {
              let channelId =
                typeof this.lastPayStore === 'string'
                  ? this.lastPayStore
                  : this.lastPayStore.id
              this.curStore =
                this.denominations.find((item) => item.id === channelId) || {}
              this.lastPayStore = ''
            } else if (this.pointsGap) {
              let curStore =
                this.denominations.find(
                  (item) => +item.platformValue >= this.pointsGap
                ) || this.denominations[this.denominations.length - 1]
              this.curStore = curStore
            }
          } else {
            this.showTipsPopup(res.msg)
          }
        })
        .catch((err) => {
          this.showTipsPopup(err.message || '系統錯誤')
        })
    },
    selectStore (data) {
      if (data.id === this.curStore.id) {
        this.curStore = {}
        return
      }
      this.curStore = data
      this.$datain({ ext3: '選擇金額', ext11: this.curStore.id || 0 })
    },
    initData (data) {
      const serialRegions = (obj) => {
        let keys = Object.keys(obj)
        return keys.map((key) => {
          let item = {
            id: key,
            name: obj[key][1],
            eName: obj[key][0]
          }
          return item
        })
      }
      let reStore = this.$route.query.reStore
      this.userName = data.user_info.LOGIN_ACCOUNT
      this.avatar = data.user_info.AVATAR
      this.$store.commit('setUserInfo', {
        ...this.userInfo,
        account_name: this.userName,
        UID: data.user_info.UID,
        avatar: data.user_info.AVATAR
      })
      this.regions = serialRegions(data.all_locations)
      if (!reStore) {
        this.curRegion =
          this.regions.find((item) => item.id === data.current_location) || {}
        if (data.last_pay_info) {
          this.init = true
          this.$nextTick(() => {
            this.lastPayChannel = data.last_pay_info.PAY_TYPE_MENU
              ? data.last_pay_info.PAY_TYPE_MENU
              : data.last_pay_info.PAY_WAY_TYPE
            this.lastPaySubChannel = data.last_pay_info.PAY_TYPE_MENU
              ? data.last_pay_info.PAY_WAY_TYPE
              : ''
          })
        }
        this.genChannels({ channels: data.pay_types, isOpenCoupon: this.isOpenCoupon })
        let channel = { id: data.pay_types[0][1] }
        this.denominations = data.products.map((item) => {
          item.id = item.PRODUCT_ID
          if (channel.id === 'virtual_account') {
            item.name =
              item.TRANS_AMOUNT + item.CURRENCY + `=${item.POINTS}G幣`
          } else if (channel.info && channel.info.isPoints) {
            item.name = `${item.TRANS_AMOUNT}點=${item.POINTS}G幣`
          } else {
            item.name = `${item.TRANS_AMOUNT}${item.CURRENCY}=${item.POINTS}G幣`
          }
          item.platformValue = item.POINTS
          item.realValue = item.TRANS_AMOUNT
          if (+item.COUPON_POINTS_NUM && this.isOpenCoupon) {
            item.couponMsg = item.more = `贈${item.COUPON_POINTS_NUM}G幣抵用券*${item.COUPON_NUM}張`
          }
          return item
        })
        if (this.pointsGap) {
          let curStore =
            this.denominations.find(
              (item) => +item.platformValue >= this.pointsGap
            ) || this.denominations[this.denominations.length - 1]
          this.curStore = curStore
        }
      } else {
        this.init = true
        this.$nextTick(() => {
          let storeParams = JSON.parse(
            window.localStorage.getItem('storeParams')
          )
          this.lastPayChannel = storeParams.curChannel
          this.lastPaySubChannel = storeParams.curSubchannel
          this.lastPayStore = storeParams.curStore
          this.curRegion = storeParams.curRegion
          this.$router.replace({ name: this.$route.name })
          // window.localStorage.removeItem('storeParams')
        })
      }
      this.walletBalance = data.user_info.POINTS
      this.storeParams = {
        gameId: data.game_id,
        gameName: data.game_name,
        serverId: data.server_id,
        serverName: data.server_name,
        roleId: data.role_id,
        roleName: data.role_name
      }
      this.$store.commit('setLoadingState', false)
    }
  },
  created () {
    let params = convertStringToParam(window.location.search)
    let pointsData = {}
    this.tmpHref = window.location.href
    this.pointsGap = +(this.$route.query.gap || 0)
    let gameId = params.gameId || this.$route.query.gameId
    this.isOpenCoupon = +gameId !== 30
    if (this.pointsGap) {
      let query = this.$route.query
      this.fromUrl = decodeURIComponent(this.$route.query.fromUrl)
      pointsData = {
        game_id: query.gameId,
        game_name: query.gameName,
        server_id: query.serverId,
        server_name: query.serverName,
        role_id: query.roleId,
        role_name: query.roleName
      }
    }
    this.$jsonp('//mstore.gm99.com/points/init_data', params)
      .then((res) => {
        let data = res.data
        if (+res.result >= 1) {
          if (this.pointsGap) {
            data = Object.assign({}, data, pointsData)
          }
          this.initData(data)
        } else {
          this.showTipsPopup(res.msg)
        }
      })
      .catch((err) => {
        this.showTipsPopup(err.message || '系統錯誤')
      })
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/store.scss";
</style>
